import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { RegisterRequest } from 'src/app/models/registerRequest';
import { UserDataService } from 'src/app/services/user-data.service';
import { EventService } from 'src/app/services/event.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  clickFirst = false;
  clickSecond = false;
  clickThird = false;
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  showPassword = false;

  firstNameError?: string = null;
  lastNameError?: string = null;
  emailError?: string = null;
  passwordError?: string = null;

  constructor(private router: Router,
    private userService: UserService,
    private userDataService: UserDataService,
    private eventService: EventService,
    private translate: TranslateService) { }

  ngOnInit(): void {
  }

  clickCheckbox1() {
    if (this.clickFirst === false) {
      this.clickFirst = true;
    } else {
      this.clickFirst = false;
    }
  }

  clickCheckbox2() {
    if (this.clickSecond === false) {
      this.clickSecond = true;
    } else {
      this.clickSecond = false;
    }
  }

  clickCheckbox3() {
    if (this.clickThird === false) {
      this.clickThird = true;
    } else {
      this.clickThird = false;
    }
  }

  createAccount() {
    if (!this.firstName || this.firstName.trim().length === 0) {
      this.firstNameError = this.translate.instant('required_field');
    } else {
      this.firstNameError = null;
    }

    if (!this.lastName || this.lastName.trim().length === 0) {
      this.lastNameError = this.translate.instant('required_field');
    } else {
      this.lastNameError = null;
    }

    const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.email || this.email.trim().length === 0) {
      this.emailError = this.translate.instant('required_field');
    } else if (!regexp.test(this.email)) {
      this.emailError = this.translate.instant('invalid_email');
    } else {
      this.emailError = null;
    }

    const pwRegexp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*\(\)_\-+=\{\}\[\]|:;"'<>,.\?/~`\\])[a-zA-Z0-9!@#$%^&*\(\)_\-+=\{\}\[\]|:;"'<>,.\?/~`\\]{12,}$/;
    if (!this.password || this.password.trim().length === 0) {
      this.passwordError = this.translate.instant('required_field');
    } else if (!pwRegexp.test(this.password)) {
      this.passwordError = this.translate.instant('invalid_password');
    } else if (this.firstName && this.password.toLowerCase().indexOf(this.firstName.trim().toLowerCase()) !== -1) {
      this.passwordError = this.translate.instant('invalid_password');
    } else if (this.lastName && this.password.toLowerCase().indexOf(this.lastName.trim().toLowerCase()) !== -1) {
      this.passwordError = this.translate.instant('invalid_password');
    } else {
      this.passwordError = null;
    }

    if (this.firstNameError || this.lastNameError || this.emailError || this.passwordError) {
      return;
    }

    this.eventService.showSpinner();
    const userRegister: RegisterRequest = {
      firstName: this.firstName.trim(),
      lastName: this.lastName.trim(),
      email: this.email.trim(),
      password: this.password.trim(),
      news: this.clickThird
    };
    this.userService.registerUser(userRegister).then(response => {
      console.log(response);
      localStorage.setItem('token', response.accessToken);
      this.userDataService.checkUser().then(user => {
        console.log(user);
        if (user !== null) {
          if (this.userDataService.configuratorStatus) {
            this.router.navigate(['/configurator'], { queryParams: { id: this.userDataService.configuratorStatus.id } });
          } else {
            this.router.navigate(['/home']);
          }
        } else {
          this.eventService.hideSpinner();
        }
      }).catch(error => {
        this.eventService.hideSpinner();
        console.log(error);
        this.eventService.setTextPopupText(this.translate.instant('error_create_user'));
        this.eventService.showTextPopup();
        return null;
      });
    }).catch(error => {
      this.eventService.hideSpinner();
      console.log(error);
      this.eventService.setTextPopupText(this.translate.instant('error_create_user'));
      this.eventService.showTextPopup();
      return null;
    });
  }

  goToLoginPage() {
    this.router.navigate(['/login']);
  }

  showHidePassword() {
    this.showPassword = !this.showPassword;
  }
}
